const ORGANIZATION_ID_KEY = 'organizationId';
export function setOrganizationId(organizationId) {
    localStorage.setItem(ORGANIZATION_ID_KEY, organizationId.toString());
}
export function removeOrganizationId() {
    localStorage.removeItem(ORGANIZATION_ID_KEY);
}
export function getOrganizationId() {
    const value = localStorage.getItem(ORGANIZATION_ID_KEY);
    if (value) {
        return Number(value);
    }
    return null;
}
//# sourceMappingURL=organization.js.map